import React from 'react'
import { useNavigate } from "react-router-dom";
import Button from '../../../../ui/Button.js'
import ResultsView from '../ResultsView.js'




export default function FormPage3(props) {
    const email = "support@kizabo.com"

    //count down timer for resend link
    //fetch to resend
    //reset the timer when resend is clicked. And change text to "File has been resent. Check your inbox and spam folder. Resend in (150) seconds..."
    // When the first email failed, resending is available straight away
    const emailFailed = props.emailSent === false;
    const [timer, setTimer] = React.useState(emailFailed ? 0 : 120);
    const [resendCtr, setResendCtr] = React.useState(0);
    const [resendStatus, setResendStatus] = React.useState(""); // "", "sent" or "error"

    const navigate = useNavigate();

    React.useEffect(() => {
        // No countdown before the first resend if the original email failed
        let ctrTimer = (resendCtr === 0 && emailFailed) ? 0 : 120; // 120 seconds
        const interval = setInterval(() => {
            if (ctrTimer > 0) {
                ctrTimer--;
                setTimer(ctrTimer)
            } else {
                clearInterval(interval);
            }
        }, 1000);

        return () => clearInterval(interval); // Cleanup on unmount
    }, [resendCtr, emailFailed]);

    function handleClick() {
        // Logic to resend the email
        console.log("Resend email clicked");


        if (timer === 0) {
            // Reset timer
            setTimer(120);
            const ctrNextTimer = resendCtr + 1;
            setResendCtr(ctrNextTimer)
            setResendStatus("")

            fetch(`${process.env.REACT_APP_BACKEND_URL}/api/v1/resend/`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': process.env.REACT_APP_KIZABO_API_KEY },
                body: JSON.stringify({
                    id: props.userId,
                })
            }).then(response => {
                if (!response.ok) {
                    throw new Error(`Resend failed with status ${response.status}`);
                }
                return response.json(); // parse JSON body
            }).then(data => {
                console.log("Email was sent successfully", data);
                setResendStatus("sent");
            }).catch(error => {
                console.error("Resend failed:", error);
                setResendStatus("error");
            });
        }

    }

    const resendMessage = (timer !== 0) ? `Resend in (${timer}) seconds` : "Resend email"

    return (
        <div className="Form">
            <div className="Form--inputs-container">
                {!emailFailed &&
                    <svg className="SuccessCheck" viewBox="0 0 64 64" aria-hidden="true">
                        <circle className="SuccessCheck--circle" cx="32" cy="32" r="32" />
                        <path className="SuccessCheck--mark" d="M19 33 l9 9 l17 -18" />
                    </svg>}
                {emailFailed ?
                    <p className="Form--instructions">Your results are ready, but we couldn’t email them to <span className="Form--instructions-bold">{props.email}</span> just now. Please try again: <button type="button" className="Form--instructions-clickable LinkButton" onClick={handleClick}>{resendMessage}</button>. How was the experience? Reach out to us via <a className="Form--instructions-clickable" href={`mailto:${email}`}>{email}</a>
                    </p> :
                <p className="Form--instructions">The results have been sent to your email <span className="Form--instructions-bold">{props.email}</span>. Check your inbox and your spam folder. Haven’t received the results? <button type="button" className="Form--instructions-clickable LinkButton" onClick={handleClick}>{resendMessage}</button>.

                    How was the experience? Reach out to us via <a className="Form--instructions-clickable" href={`mailto:${email}`}>{email}</a>
                </p>}
                <p className="Form--instructions Form--resend-status" role="status">
                    {resendStatus === "sent" && "We've sent the email again. Check your inbox and spam folder."}
                    {resendStatus === "error" && "We couldn't resend the email. Please try again when the timer reaches zero."}
                </p>
                {props.results && <ResultsView results={props.results} />}
                <Button className="Form--website-cta" onClick={()=>{navigate("/login")}}>Find compatible co-founders!</Button>

            </div>

        </div>
    )
}